module.exports = __webpack_public_path__ + "static/img/bf-top-bg.c38bd97b.png";